//import { postBiz } from './bieForecastDataMartApi';
import { postBiz } from './bie.apis';

const rows = (json: any) => {
  const sd = json.sd || json.result?.sd || json.data?.sd;
  return Array.isArray(sd) ? sd : [];
};

export const buildScenarioAssumptions = (scc = 'DET2027_BASE') =>
  postBiz({ s: 'biescenarioassumption', a: 'build', scc });

export const fetchScenarioAssumptions = async (scc = 'DET2027_BASE') =>
  rows(await postBiz({ s: 'biescenarioassumption', a: 'find', scc }));

export const saveScenarioAssumptions = (scc = 'DET2027_BASE', rcd: any[]) =>
  postBiz({ s: 'biescenarioassumption', a: 'save', scc, rcd });

export const fetchScenarioAssumptionSummary = (scc = 'DET2027_BASE') =>
  postBiz({ s: 'biescenarioassumption', a: 'summary', scc });
